export default __webpack_public_path__ + "static/media/Bing-sound.f90458c5.mp3";